<template>
	<div class="m-grid__item m-grid__item--fluid m-wrapper user-info">
		<div class="m-content">
			<div class="row">
				<div class="col-xl-12">
					<div class="m-portlet m-portlet--full-height ">
						<div class="m-portlet__head">
							<div class="m-portlet__head-caption">
								<div class="m-portlet__head-title">
									<h3 class="m-portlet__head-text">
										Thông báo
									</h3>
								</div>
							</div>
							<div class="m-portlet__head-tools" v-if="user.role=='admin'">
								<button type="button" class="btn btn-primary" nid="-1" @click="showModel">Tạo thông báo</button>
							</div>
						</div>
						<div class="m-portlet__body">
							<div class="m-widget3">
								<div :class="'m-widget3__item ' + getStatusClass(n.status)" v-for="n in notifys">
									<div class="m-widget3__header">
										<div class="m-widget3__user-img">
											<a href="#" :class="'btn m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill btn-outline-' + getTypeName(n.type).className">
												<i :class="'la la-' + getTypeName(n.type).iconName"></i>
											</a>
										</div>
										<div class="m-widget3__info">
											<span class="m-widget3__username">
												{{n.title}}
											</span><br>
											<span class="m-widget3__time">
												{{n.created_at}}
											</span>
										</div>
										<div class="m-btn-group m-btn-group--pill btn-group" v-if="user.role=='admin'">
											<button type="button" class="m-btn btn btn-secondary" :nid="n.id" @click="showModel"><i class="la la-edit"></i></button>
											<button type="button" class="m-btn btn btn-secondary" :nid="n.id" @click="showDetele"><i class="la la-trash-o"></i></button>
										</div>
									</div>
									<div class="m-widget3__body">
										<p class="m-widget3__text">
											{{n.content}}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="m_modal_nofify" tabindex="-1" role="dialog">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title"></h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form class="m-form m-form--fit m-form--label-align-right">
							<div class="form-group">
								<label for="recipient-name" class="form-control-label">Thành viên:</label>
								<div class="input-group">
									<input type="text" class="form-control" name="code">
									<div class="input-group-append">
										<span class="input-group-text">
											<label class="m-checkbox m-checkbox--single m-checkbox--state m-checkbox--state-primary">
												<input type="checkbox" name="child">
												<span></span>
											</label>
										</span>
									</div>
								</div>
								<span class="m-form__help">Tích để gửi đến tất cả cấp dưới</span>
							</div>
							<div class="form-group">
								<label for="recipient-name" class="form-control-label">Tiêu đề:</label>
								<input type="text" class="form-control" name="title">
							</div>
							<div class="form-group">
								<label for="message-text" class="form-control-label">Nội dung:</label>
								<textarea class="form-control" name="content"></textarea>
							</div>
							<div class="form-group">
								<label for="message-text" class="form-control-label">Kiểu:</label>
								<select class="form-control m-input m-input--square" name="type">
									<option value="3">Thông báo</option>
									<option value="1">Nguy hiểm</option>
									<option value="2">Cảnh báo</option>
								</select>
							</div>
							<div class="form-group">
								<label for="message-text" class="form-control-label">Trạng thái:</label>
								<select class="form-control m-input m-input--square" name="status">
									<option value="1">Có thông báo</option>
									<option value="0">Không thông báo</option>
									<option value="-1">Ẩn</option>
								</select>
							</div>
							<div class="form-group">
								<label for="message-text" class="form-control-label">Thời gian:</label>
								<input class="form-control m-input" type="datetime-local" value="" name="time">
							</div>
						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary modal-submit" @click="submitAdd()"></button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from "../utilities";

    export default {
		data() {
            return {
				notifys: [],
            }
        },

        created: function(){
        	this.getNotify();
        },

        computed: {
			...mapGetters({
				user: 'user',
		  		userBudget: 'userBudget',
		  		gameInfo: 'gameInfo'
			}),
		},

        methods: {
			getNotify: async function(){
				let vm = this;
				let notifys = await window.axios.get("/admin-panel/notify/get");
	            vm.notifys = notifys.data.data;
			},
			showModel: function(e){
				var id = $(e.currentTarget).attr("nid");
				var n = this.getNotiById(id);
				this.setDataModal(n);

				var modal_title = id == -1 ? "Tạo thông báo" : "Sửa thông báo";
				var modal_submit = id == -1 ? "Tạo" : "Sửa";

	        	$("#m_modal_nofify .modal-title").html(modal_title);
	        	$("#m_modal_nofify .modal-submit").html(modal_submit);
	        	$("#m_modal_nofify").modal();     	
	        },
			showDetele: function(e){
	        	var id = $(e.currentTarget).attr("nid");

				window.axios.delete("admin-panel/notify/delete/" + id)
				.then((response) => {
			    	if(response.data.code == 0){
			    		swal("", res.msg, "success");
			    		this.getNotify();
			    	}
			    })
			    .catch((error) => { });
	        },
	        submitAdd: function(){
	        	var data = this.getDataModal();

        		window.axios.post("admin-panel/notify/add", data)
			    .then((response) => {
			    	if(response.data.code == 0){
			    		swal("", "Tạo thành công", "success");
			    		$("#m_modal_nofify").modal('hide');
			    		this.getNotify();
			    	}
			    })
			    .catch((error) => { });
				
	        },
			getStatusClass: function(status){
				return status == -1 ? "hide" : "";
			},
			getTypeName: function(type){
				var className = "";
				var iconName = "";
				switch(type){
					case 1://warning
						className = "warning";
						iconName = "warning";
						break;
					case 2://danger
						className = "danger";
						iconName = "bomb";
						break;
					case 3://success
						className = "success";
						iconName = "bell";
						break;
				}

				return {
							className:className, 
							iconName:iconName
						};
			},
			getNotiById: function(id){
				var ns = this.notifys;
				for(var i in ns){
					if(id == ns[i].id) return ns[i];
				}
				return {
					id: -1,
					title: "",
					content: "",
					code: "",
					child: false,
					type: 1,
					status: 1,
					created_at: moment().format("YYYY-MM-DD HH:mm:ss.SSSS"),
				}
			},
			setDataModal: function(n){
				var modal = $("#m_modal_nofify");
				modal.attr('nid', n.id);
				modal.find("input[name='title']").val(n.title);
				modal.find("textarea[name='content']").val(n.content);
				modal.find("input[name='code']").val(n.code);
				modal.find("input[name='child']").prop( "checked", n.child);
				modal.find("select[name='type']").val(n.type);
				modal.find("select[name='status']").val(n.status);
				modal.find("input[name='time']").val(moment(n.created_at, "YYYY-MM-DD HH:mm:ss.SSSS").format('YYYY-MM-DDTHH:mm'));
			},
			getDataModal: function(){
				var modal = $("#m_modal_nofify");

				var id = modal.attr('nid');
				var title = modal.find("input[name='title']").val();
				var content = modal.find("textarea[name='content']").val();
				var code = modal.find("input[name='code']").val();
				var child = modal.find("input[name='child']").prop("checked");
				var type = modal.find("select[name='type']").val();
				var status = modal.find("select[name='status']").val();
				var created_at = moment(modal.find("input[name='time']").val(), moment.ISO_8601).format("YYYY-MM-DD HH:mm:ss");

				return {
					id: id,
					title: title,
					content: content,
					code: code,
					child: child,
					type: type,
					status: status,
					created_at: created_at,
				}
			}
		}
	}
</script>

<style>
    .m-widget3__item.hide{
    	text-decoration: line-through;
    }
</style>